var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUncompletedTraining(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 24,
    viewBox: "0 0 40 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0001 20.3333V23.6666H35.0001V20.3333C35.0001 17.75 33.8334 15.4333 31.9668 13.7666C40.0001 14.5833 40.0001 20.3333 40.0001 20.3333ZM30.0001 0.333313C32.7668 0.333313 35.0001 2.56665 35.0001 5.33331C35.0011 6.1186 34.8168 6.89304 34.4622 7.59374C34.1077 8.29444 33.5929 8.90164 32.9596 9.36603C32.3264 9.83042 31.5925 10.1389 30.8177 10.2664C30.0428 10.394 29.2488 10.3369 28.5001 10.1C29.4501 8.74998 30.0001 7.11665 30.0001 5.33331C30.0001 3.56665 29.4501 1.91665 28.5001 0.566646C28.9668 0.416646 29.4834 0.333313 30.0001 0.333313ZM21.6668 0.333313C24.4334 0.333313 26.6668 2.56665 26.6668 5.33331C26.6668 8.09998 24.4334 10.3333 21.6668 10.3333C18.9001 10.3333 16.6668 8.09998 16.6668 5.33331C16.6668 2.56665 18.9001 0.333313 21.6668 0.333313ZM31.6668 20.3333V23.6666H11.6668V20.3333C11.6668 16.65 16.1501 13.6666 21.6668 13.6666C27.1834 13.6666 31.6668 16.65 31.6668 20.3333ZM0.773438 13.8666L4.31677 10.3333L0.773438 6.79998L3.13344 4.43331L6.66677 7.98331L10.2001 4.43331L12.5668 6.79998L9.01677 10.3333L12.5668 13.8666L10.2001 16.2333L6.66677 12.6833L3.13344 16.2333L0.773438 13.8666Z",
    fill: "#0E2C66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUncompletedTraining);
export default __webpack_public_path__ + "static/media/uncompleted_training.7929e73c51ad5928d78bb8a1d8bcf5ff.svg";
export { ForwardRef as ReactComponent };